import { ErrorBoundary } from 'react-error-boundary';
import Error from '@screens/Error/Error';
import { FormProvider } from '@context/FormContext';
import StepFormContainer from '@containers/StepFormContainer';
import { useAlertWhenUserLeaves } from '@shared/hooks/useAlertWhenUserLeaves';
import { AppProvider } from '@context/appContext';
import { ProveProvider } from '@context/proveProvider';
import { AnalyticsProvider } from '@context/analyticsContext';

const Widget = ({ initValues = {} }) => {
  useAlertWhenUserLeaves();

  return (
    <div>
      <ErrorBoundary fallbackRender={Error}>
        <AppProvider>
          <AnalyticsProvider>
          <FormProvider>
            <ProveProvider>
              <StepFormContainer initValues={initValues} />
            </ProveProvider>
          </FormProvider>
          </AnalyticsProvider>
        </AppProvider>
      </ErrorBoundary>
    </div>
  );
};

export default Widget;
